import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "w100 pad40 centered",
  style: {"height":"170px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "title mc" }, [
    /*#__PURE__*/_createElementVNode("p", {
      class: "header_title fs24 centered",
      style: {"color":"#696969"}
    }, "日程を確認しています...")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "clear" }),
  /*#__PURE__*/_createElementVNode("p", { class: "fs14" }, [
    /*#__PURE__*/_createTextVNode("確定できるか日程を確認しています。 "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("しばらくお待ちください。")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_progress_bar = _resolveComponent("md-progress-bar")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "FixLoadingModal",
    "content-class": "modalContent shadowContent rad10 modalNarrow posFi"
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_md_progress_bar, { key: 0 }))
        : _createCommentVNode("", true),
      _hoisted_1
    ]),
    _: 1
  }))
}